<template>
  <section class="section content user-form">
    <h2 v-html="title" />
    <ValidationObserver
      tag="form"
      :id="winner_type"
      :name="winner_type"
      class="form"
      ref="observer"
    >
      <div
        class="columns is-multiline"
        v-for="(page, key) in layout"
        :key="key"
      >
        <div
          v-for="(field, key) in page"
          :key="key"
          :class="computeFieldClass(field)"
        >
          <label
            :for="field.name"
            :class="computeLabelClass(field)"
            v-if="shouldShowLabel(field)"
            v-html="field.label"
          />

          <div class="field-body" v-if="field.nested">
            <div class="field" v-for="(subfield, key) in field.nested" :key="key">
              <FormHtml :field="subfield" v-if="subfield.type === 'html'" />
              <FormSelect :field="subfield" v-else-if="subfield.type === 'select'" />
              <FormTextArea :field="subfield" v-else-if="subfield.type === 'textarea'" />
              <FormInput :field="subfield" v-else />
            </div>
          </div>
          <div class="field-body" v-else>
            <div class="field">
              <FormHtml :field="field" v-if="field.type === 'html'" />
              <FormSelect :field="field" v-else-if="field.type === 'select'" />
              <FormSlider :field="field" v-else-if="field.type === 'slider'" />
              <FormTextArea :field="field" v-else-if="field.type === 'textarea'" />
              <FormRadio :field="field" v-else-if="field.type === 'radio'" />
              <FormCheckbox :field="field" v-else-if="field.type === 'checkbox'" />
              <FormInput :field="field" v-else />
            </div>
          </div>
        </div>
      </div>
      <Submit :winner_type="winner_type" />
    </ValidationObserver>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import {
  FormInput, FormTextArea, FormCheckbox, FormHtml, FormRadio,
  FormSelect, FormSlider,
} from 'djx-form';
import Submit from '../components/Submit.vue';

export default {
  props: {
    winner_type: String,
  },
  computed: {
    ...mapState({
      layout(state) {
        return state[this.$route.params.slug][this.winner_type].layout;
      },
    }),
    title() {
      if (this.winner_type === 'update_info') {
        return 'Update Your Info';
      }
      return 'Advertise';
    }
  },
  methods: {
    computeFieldClass(field) {
      const classes = ['is-horizontal', 'column', 'is-12', 'is-marginless', `${field.type}-container`];
      if (field.type !== 'nomination') {
        classes.push('field');
      }
      if (field.labelAbove === true) {
        classes.shift(); // This is `is-horizontal`, as it's the first item
      }
      return classes;
    },
    computeLabelClass(field) {
      const classes = ['field-label', 'has-text-weight-bold'];

      if (field.type !== 'radio') {
        classes.push('is-normal');
      }

      return classes;
    },
    shouldShowLabel(field) {
      if (field.type === 'checkbox') {
        return field.options && field.options.length > 0;
      }
      return !['html'].includes(field.type) && field.label;
    },
  },
  components: {
    FormInput,
    FormSelect,
    FormSlider,
    FormTextArea,
    FormHtml,
    FormRadio,
    FormCheckbox,
    Submit,
  },
};
</script>
